<template>
  <div class="page_container">
    <div class="container">
      <div class="title" v-if="siteList.length">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="operationGroupId"
            :options="opeOptions"
            @change="opeChange"
          />
          <van-dropdown-item
            title-class="title_item"
            :title="siteList[selected].cabinetName"
            ref="site"
          >
            <div class="search-box whiteBg">
              <search-input
                @search="handleSearch"
                ref="searchInput"
                placeholder="输入网点名称搜索"
                immediately
              ></search-input>
            </div>
            <div class="search_result">
              <div class="noData" v-show="noData">
                没有找到符合条件的网点
              </div>
              <template v-for="(item, index) in siteList">
                <van-cell
                  :key="item.siteId"
                  v-if="!item.hide"
                  center
                  :title="item.cabinetName"
                  :title-style="index === selected ? 'color:#EE0A24' : ''"
                  @click="chooseSiteItem(index)"
                >
                  <template
                    #right-icon
                    v-if="item.cabinetId === siteList[selected].cabinetId"
                  >
                    <van-icon name="success" color="#EE0A24" />
                  </template>
                </van-cell>
              </template>
            </div>
          </van-dropdown-item>
          <van-dropdown-item :title="dateOptions[dateType].text" ref="date">
            <van-cell
              v-for="item in dateOptions"
              :key="item.value"
              center
              :title="item.text"
              :title-style="item.value === dateType ? 'color:#EE0A24' : ''"
              @click="chooseDateItem(item.value)"
            >
              <template
                #right-icon
                v-if="item.value === dateOptions[dateType].value"
              >
                <van-icon name="success" color="#EE0A24" />
              </template>
            </van-cell>
            <div class="time-picker-box" v-show="dateType === 4">
              <div class="picker">
                <div class="startTime" @click="showCalendar('start')">
                  {{ startTime ? startTime : '开始时间' }}
                </div>
                <div class="endTime" @click="showCalendar('end')">
                  {{ endTime ? endTime : '结束时间' }}
                </div>
              </div>
              <van-button
                class="confirmPicker"
                round
                color="#EE0A24"
                size="small"
                @click="comfirmDate"
                >确认</van-button
              >
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        <div class="feature">
          <export-button
            :dates="dates"
            :dateOptions="dateOptions"
            :id="operationGroupId"
            :area="getAreaObj"
            :ope="getOpeObj"
          ></export-button>
        </div>
      </div>
      <div class="top_data_box">
        <div class="top_data">
          <div
            class="top_data_item"
            v-for="(item, index) in reportList"
            :key="index"
          >
            <div>{{ item.label }}</div>
            <div class="number">
              {{ expressInfo ? expressInfo[item.key] : 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="chart_container">
        <div class="chart">
          <div>派送量</div>
          <div class="main" ref="rkDom"></div>
        </div>
        <div class="chart">
          <div>派送品牌</div>
          <div class="main" ref="rkppDom"></div>
        </div>
        <div class="chart">
          <div>签收量</div>
          <div class="main" ref="ckDom"></div>
        </div>
        <div class="chart">
          <div>签收品牌</div>
          <div class="main" ref="ckppDom"></div>
        </div>
      </div>
      <van-calendar
        v-model="calendarShow"
        :min-date="new Date('2020-01-01')"
        :max-date="new Date()"
        row-height="30"
        ref="calendar"
        :show-confirm="false"
        @confirm="calenderConfirm"
        @closed="() => this.$refs.date.toggle()"
      />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import searchInput from '@/components/search'
import exportButton from './component/cabExport.vue'
export default {
  data() {
    return {
      noData: false,
      selected: 0, // 站点选择索引
      siteList: [
        {
          cabinetId: '',
          cabinetName: '全部网点'
        }
      ],
      siteOptions: [],
      dates: [],
      dateType: 0, // 日期选择索引
      dateOptions: [
        { text: '今日', value: 0 },
        { text: '近7日', value: 1 }
      ],
      opeOptions: [],
      calendarShow: false,
      reportList: [
        {
          label: '派送量',
          key: 'instoreNum'
        },
        {
          label: '签收量',
          key: 'signNum'
        },
        {
          label: '待签收',
          key: 'inventoryNum'
        }
      ],
      expressInfo: {
        instoreNum: 0,
        signNum: 0,
        inventoryNum: 0
      },
      today: '',
      rkDom: null,
      ckDom: null,
      rkppDom: null,
      ckppDom: null,
      lalong: '120.344875,30.739927',
      operationGroupId: '',
      startTime: '',
      endTime: ''
    }
  },
  components: {
    searchInput,
    exportButton
  },
  created() {},
  mounted() {
    this.getToday()
    this.getDateOptions()
  },
  computed: {
    getAreaObj() {
      let obj = {
        areaId: '',
        areaName: '全部地区'
      }
      return obj
    },
    getOpeObj() {
      let obj = {}
      for (let i = 0; i < this.opeOptions.length; i++) {
        if (this.opeOptions[i].value === this.operationGroupId) {
          obj = this.opeOptions[i]
          break
        }
      }
      return obj
    }
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        if (this.rkDom && this.ckDom && this.rkppDom && this.ckppDom) {
          this.getData()
        } else {
          this.rkDom = echarts.init(this.$refs.rkDom)
          this.ckDom = echarts.init(this.$refs.ckDom)
          this.rkppDom = echarts.init(this.$refs.rkppDom)
          this.ckppDom = echarts.init(this.$refs.ckppDom)
          this.getData()
        }
        this.render()
      })
    },
    render() {
      window.onresize = () => {
        this.rkDom.resize()
        this.ckDom.resize()
        this.rkppDom.resize()
        this.ckppDom.resize()
      }
    },
    getData() {
      // this.dateChange()
      this.$api.tyCab.getCabGroupList().then(res => {
        let opeList = [
          {
            groupId: '',
            groupName: '全部运营组'
          }
        ]
        opeList = [...opeList, ...res]
        let list = []
        opeList.map((item, i) => {
          list.push({
            text: item.groupName,
            value: item.groupId
          })
        })
        this.opeOptions = list
        this.getSiteList()
      })
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 100)
    },
    opeChange() {
      this.selected = 0
      this.$refs.searchInput && this.$refs.searchInput.clear()
      this.getSiteList()
    },
    // 站点搜索
    handleSearch(value) {
      let reg = new RegExp(value)
      let num = 0
      this.siteList.map(i => {
        if (!i.cabinetName.match(reg)) {
          i.hide = true
        } else {
          i.hide = false
          num++
        }
      })
      this.noData = num === 0
    },
    // 选择站点
    chooseSiteItem(index) {
      this.selected = index
      this.$refs.site.toggle()
      this.dateChange()
    },
    // 选择时间
    chooseDateItem(index) {
      this.dateType = index
      if (index !== 4) {
        this.$refs.date.toggle()
        this.dateChange()
      }
    },
    showCalendar(e) {
      this.$refs.date.toggle()
      this.time = e + 'Time'
      this.calendarShow = true
      let date = this[e + 'Time'] !== '' ? new Date(this[e + 'Time']) : ''
      if (date) this.$refs.calendar.reset(date)
    },
    calenderConfirm(value) {
      const time = this.formatDate(value)
      // this.calendarShow = false
      this[this.time] = time
      this.calendarShow = false
      console.log(time)
    },
    comfirmDate() {
      if (this.startTime === '' || this.endTime === '') {
        this.$toast('请选择时间段')
        return
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        this.$toast('请选择正确的时间段')
        return
      }
      this.dateChange()
      this.$refs.date.toggle()
    },
    // 获取站点列表
    getSiteList() {
      let params = {
        operationGroupId: this.operationGroupId
      }
      this.$api.tyCab.getCabList(params).then(res => {
        let siteList = [
          {
            cabinetName: '全部网点',
            cabinetId: '',
            hide: false
          }
        ]
        siteList = [...siteList, ...res]
        let list = []
        siteList.map((item, i) => {
          item.hide = false
          list.push({
            text: item.cabinetName,
            value: i
          })
        })
        this.siteList = siteList
        this.siteOptions = list
        this.dateChange()
      })
    },
    getToday() {
      let date = new Date()
      this.startTime = this.endTime = this.today = this.formatDate(date)
    },
    getDateOptions() {
      let dates = this.createDateDate(2)
      let arr = this.dateOptions
      let index = arr.length
      for (let i of dates) {
        let obj = {
          text: i.label,
          value: index
        }
        arr.push(obj)
        index++
      }
      arr.push({
        text: '自定义',
        value: index
      })
      this.dateOptions = arr
      this.dates = dates
    },
    /** 获取前monthNum个月的月份 */
    createDateDate(monthNum) {
      let dataArr = []
      let data = new Date()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份z
      for (let i = 0; i < monthNum; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        let text = i === 0 ? '本' : i === 1 ? '上' : ''
        let obj = {
          label: (text || m) + '月',
          date: data.getFullYear() + '-' + (m < 10 ? '0' + m : m)
        }
        dataArr.push(obj)
      }
      return dataArr
    },
    // 格式化日期：yyyy-MM-dd
    formatDate(date, type = 0) {
      if (type) {
        date = date.date
      }
      let myyear = date.getFullYear()
      let mymonth = date.getMonth() + 1
      let myweekday = date.getDate()
      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      return myyear + '-' + mymonth + '-' + myweekday
    },
    dateChange(e) {
      this.getInOutAbData(0)
      this.getInOutAbData(1)
      this.getInOutAbData(2)
      // this.getInOutAbData('')
      this.getChartRk(1)
      this.getChartRk(2)
      this.getChartCompany(1)
      this.getChartCompany(2)
    },
    // 获取出入库图表数据 type 1入库 2出库
    getChartRk(type) {
      let [startTime, endTime] = this.getStartEndTime()
      const params = {
        cabinetId: this.siteList[this.selected].cabinetId,
        operationGroupId: this.operationGroupId,
        startTime,
        endTime
      }
      let url = ''
      switch (type) {
        case 1:
          url = 'getRKChartByCabinet'
          break
        case 2:
          url = 'getCKChartByCabinet'
          break
      }
      this.$api.tyCab[url](params).then(res => {
        let intoListLabel = []
        let intoListNum = []
        res.forEach(i => {
          intoListLabel.push(i.name.slice(5))
          intoListNum.push(i.value)
        })
        let option = {
          xAxis: {
            type: 'category',
            data: intoListLabel,
            axisLabel: {
              fontSize: 10
            }
          },
          yAxis: {
            type: 'value',
            show: false
          },
          series: [
            {
              data: intoListNum,
              type: 'bar',
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              barMaxWidth: 30,
              itemStyle: {
                normal: {
                  // 设置柱形图圆角 [左上角，右上角，右下角，左下角]
                  barBorderRadius: [5, 5, 0, 0]
                }
              }
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            confine: true
          },
          dataZoom: [
            {
              type: 'inside', // 1平移 缩放

              throttle: 50, // 设置触发视图刷新的频率。单位为毫秒（ms）。

              startValue: 0,
              endValue:
                intoListLabel.length <= 7 ? intoListLabel.length - 1 : 6,
              // preventDefaultMouseMove: false,

              zoomLock: false // 如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。
            }
          ],
          title: {
            // 无数据时占位用
            show: intoListLabel.length === 0, // 判断有没有数据，没有则show为true
            textStyle: {
              color: '#ccc',
              fontSize: 18
            },
            text: '暂无数据',
            left: 'center',
            top: 'center'
          }
        }
        switch (type) {
          case 1:
            this.rkDom.setOption(option)
            break
          case 2:
            this.ckDom.setOption(option)
            break
        }
      })
    },
    // 获取品牌图表数据 type 1入库 2出库
    getChartCompany(type) {
      let [startTime, endTime] = this.getStartEndTime()
      const params = {
        cabinetId: this.siteList[this.selected].cabinetId,
        operationGroupId: this.operationGroupId,
        startTime,
        endTime
      }
      let url = ''
      switch (type) {
        case 1:
          url = 'getRKChartByCompany'
          break
        case 2:
          url = 'getCKChartByCompany'
          break
      }

      // const data = this.$Base64.encode(JSON.stringify(params))
      this.$api.tyCab[url](params).then(res => {
        let intoList = []
        // 整理数据
        let companyObj = {
          ydNum: '韵达',
          sfNum: '顺丰',
          tmNum: '天猫',
          yzNum: '邮政',
          ytNum: '圆通',
          ztNum: '中通',
          stNum: '申通',
          dbNum: '德邦',
          jdNum: '京东',
          emsNum: 'EMS',
          jtNum: '极兔',
          fwNum: '丰网',
          bsNum: '百世',
          otherNum: '其他'
        }
        Object.entries(res).forEach(i => {
          if (companyObj[i[0]] && i[1] !== 0) {
            intoList.push({
              name: companyObj[i[0]],
              value: i[1]
            })
          }
        })
        let option = {
          legend: {
            type: 'scroll',
            show: intoList.length !== 0,
            bottom: 0,
            padding: [5, 18]
          },
          tooltip: {
            trigger: 'item'
          },

          series: [
            {
              name: type === 1 ? '派送品牌' : '签收品牌',
              type: 'pie',
              radius: '45%',
              center: ['50%', '40%'],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              data: intoList,
              label: {
                formatter: '{b} : {c}'
                // width: 90,
                // overflow: 'break'
              }
            }
          ]
        }
        switch (type) {
          case 1:
            this.rkppDom.setOption(option)
            break
          case 2:
            this.ckppDom.setOption(option)
            break
        }
      })
    },
    // type 0入库 1出库 2待出库
    getInOutAbData(type) {
      let [startTime, endTime] = this.getStartEndTime()
      const params = {
        cabinetId: this.siteList[this.selected].cabinetId,
        operationGroupId: this.operationGroupId,
        startTime,
        endTime,
        type
      }
      this.$api.tyCab.getExpressNumsTotal(params).then(res => {
        if (type === 0) {
          this.expressInfo = {
            ...this.expressInfo,
            instoreNum: res
          }
        }
        if (type === 1) {
          this.expressInfo = {
            ...this.expressInfo,
            signNum: res
          }
        }
        if (type === 2) {
          this.expressInfo = {
            ...this.expressInfo,
            inventoryNum: res
          }
        }
      })
    },
    removeEmpty(data) {
      for (let key in data) {
        if (
          data[key] === undefined ||
          data[key] === null ||
          (typeof data[key] === 'string' && data[key].trim() === '')
        ) {
          delete data[key]
        }
      }
      return data
    },
    getStartEndTime() {
      const type = this.dateType
      const today = this.formatDate(new Date())
      let _date = null
      let sdate = null
      let y, m, d
      switch (type) {
        case 0:
          return [today, today]
        case 1:
          _date = new Date(today)
          _date.setDate(_date.getDate() - 7) // 日期回到七天前
          return [this.formatDate(_date), today]
        case 2:
          return [this.dates[type - 2].date + '-01', today]
        case 3:
          sdate = new Date(this.dates[type - 2].date)
          y = sdate.getFullYear() // 获取年份
          m = sdate.getMonth() + 1 // 获取月份
          d = new Date(y, m, 0).getDate() // 获取当月最后一日
          m = m < 10 ? '0' + m : m // 月份补 0
          d = d < 10 ? '0' + d : d // 日数补 0
          return [this.dates[type - 2].date + '-01', [y, m, d].join('-')]
        case 4:
          return [this.startTime, this.endTime]
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss">
.page_container {
  .container {
    .title {
      .van-dropdown-menu__title::after {
        right: -6px;
        margin-top: -7px;
        border: 4px solid;
        border-color: transparent transparent #dcdee0 #dcdee0;
      }
      .van-dropdown-menu__title.van-dropdown-menu__title--active.van-dropdown-menu__title--down::after {
        margin-top: -3px;
      }
      // .title_item {
      //   font-size: 18px;
      //   font-weight: 700;
      // }
    }
  }
}
</style>
<style lang="scss" scoped>
.search-box {
  position: sticky;
  top: 0;
  box-sizing: border-box;
  padding: 0 10px 10px;
  width: 100%;
  overflow: hidden;
  z-index: 10;
}

.noData {
  padding: 10px;
  text-align: center;
}

.time-picker-box {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .picker {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .confirmPicker {
    margin-top: 10px;
    width: 50%;
  }
  .startTime,
  .endTime {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45%;
    height: 30px;
    border-radius: 15px;
    background-color: #f4f6fa;
  }
}

.page_container {
  background-color: #f5f7f7;
  .long {
    background: #fff;
    width: 100%;
    text-align: center;
    font-size: 14px;
    padding: 5px 0;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
    .title {
      width: 100%;
      .feature {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        height: 48px;
        background: #fff;
      }
    }
    .export_box {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 5;
    }
    .top_data_box {
      margin: 10px 0 0;
      width: 100%;
      display: flex;
      position: relative;
      overflow: hidden;
    }
    .top_data {
      width: 100%;
      display: flex;
      .top_data_item {
        // width: 25%;
        flex: 1;
        padding: 10px;
        text-align: center;
        background-color: #fff;

        .number {
          margin-top: 4px;
          color: #ff6600;
        }
      }
    }
    .chart_container {
      width: 100%;
    }
    .chart {
      padding-top: 10px;
      width: 100%;
      text-align: center;
      background-color: #fff;
      position: relative;
    }
    .main {
      box-sizing: border-box;
      width: 100%;
      min-height: 300px;
    }
  }
}
</style>
